import { render, staticRenderFns } from "./UserPhoto.vue?vue&type=template&id=de9538e2&scoped=true&"
import script from "./UserPhoto.vue?vue&type=script&lang=js&"
export * from "./UserPhoto.vue?vue&type=script&lang=js&"
import style0 from "./UserPhoto.vue?vue&type=style&index=0&id=de9538e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de9538e2",
  null
  
)

export default component.exports